import { normalizeSet } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var setClipboard = normalizeSet(function (args) {
  args.data = args.text;
  delete args.text;
  return ks.setClipboardData(args);
}, CONTAINER_NAME.KWAI);
export default setClipboard;